import {object, string} from 'yup';
import {CARDS_LIST, INNER_FIELDS} from '../constants';

const obj = {};

CARDS_LIST.forEach(({id}) => {
  const values = {};
  INNER_FIELDS.forEach((key) => {
    values[key] = string().required()
  });
  obj[id] = object(values);
});

export default object(obj);
